import React, { useState } from 'react'
import EditCatModal from './Modal/EditCatModal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { createCategory, deleteCategory, getAllCategorys, updateCategorys } from '../../Redux/preferenceSlice';
import { 
  MdDeleteForever, 
  MdOutlineCategory, 
  MdOutlineAdd,
  MdOutlineUpload,
  MdOutlineDownload,
  MdOutlineEdit,
  MdOutlineDelete
} from "react-icons/md";
import { 
  FiPlus, 
  FiEdit2, 
  FiTrash2, 
  FiUpload, 
  FiDownload, 
  FiGrid,
  FiRefreshCw,
  FiCheckCircle,
  FiXCircle,
  FiSearch,
  FiFilter,
  FiFolder,
  FiTag,
  FiHash,
  FiList,
  FiArrowRight
} from "react-icons/fi";
import SimpleDeleteModal from '../../components/Delete Modal/SimpleDeleteModal';
import { BiSolidEdit } from 'react-icons/bi';
import { baseURL } from '../../BaseURL';
import { apiRequestMedia } from '../../_helpers/apiConfig';
import UploadModal from './Modal/UploadModal';
import { toast } from 'react-toastify';

const feildsData = {
  name: "", shortName: ""
}

function PreferenceMangment() {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const { preferenceSlice: { preference } } = selector ? selector : {}
  const [error, setError] = useState({})
  const [isActionModal, setisActionModal] = useState(false)
  const [inputValue, setInputValue] = useState(feildsData)
  const [Info, setInfo] = useState({})
  const [file, setFile] = useState(null);
  const [searchTerm, setSearchTerm] = useState('')

  const toggleStatusModal = () => {
    setisActionModal((prev) => !prev)
  }

  const validateInput = () => {
    const newError = {};
    if (!inputValue.name || inputValue.name.trim() === '') {
      newError.name = 'Category name is required.';
    }
    return newError;
  }

  const handleCreateValidate = () => {
    const validationErrors = validateInput(inputValue);
    setError(validationErrors);
    autoRemoveErrors();
    return Object.keys(validationErrors).length === 0;
  };

  useEffect(() => {
    dispatch(getAllCategorys())
  }, [])

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUploadModal, setIsUploadModal] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState("");
  const [editIndex, setEditIndex] = useState(null);

  const handleCatEdit = (category, index) => {
    setSelectedCategory(category);
    setEditIndex(index);
    setIsModalOpen(true);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedCategory({ ...selectedCategory, [name]: value })
  };

  const handleSave = (e) => {
    e.preventDefault()
    let apiResData = {
      id: selectedCategory?._id,
      name: selectedCategory?.name.trim(),
      shortName: selectedCategory?.name.trim()
    }
    dispatch(updateCategorys({ Payload: apiResData }))
    setSelectedCategory(null)
    setIsModalOpen(false)
  }

  const handleCreateCat = () => {
    if (handleCreateValidate()) {
      const payload = {
        name: inputValue.name,
        shortName: inputValue.name
      };
      dispatch(createCategory({ Payload: payload }));
      setInputValue(feildsData);
    }
  };

  const handleCreateOnChange = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value })
    if (error[name]) {
      setError(prev => ({ ...prev, [name]: null }));
    }
  }

  const autoRemoveErrors = () => {
    setTimeout(() => {
      setError({});
    }, 3000);
  };

  const handleDelete = (elem) => {
    setInfo(elem)
    toggleStatusModal()
  }

  const handleSubmit = () => {
    dispatch(deleteCategory({ id: Info?._id }))
    toggleStatusModal()
  }

  const handleUploadFile = async (uploadedFile) => {
    const fileToUpload = uploadedFile || file;
    console.log("File:", fileToUpload);

    if (!fileToUpload) {
      toast.error("Please select an Excel file!");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileToUpload);

    try {
      const res = await apiRequestMedia("POST", "/v1/category/bulkUpload", formData);
      toast.success(res.message || "File uploaded successfully");
      setIsUploadModal(false);
      setFile(null);
      dispatch(getAllCategorys());
    } catch (err) {
      toast.error(err?.message || "Upload failed");
    }
  };

  const handleFileUploadModal = () => {
    setIsUploadModal(true)
  }

  const handleDownloadSample = async () => {
    window.location.href = baseURL + `/v1/category/downloadSample`;
  }

  // Filter categories based on search
  const filteredCategories = preference?.filter(cat => 
    cat?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  // Calculate statistics
  const totalCategories = filteredCategories.length;
  const sortedCategories = [...filteredCategories].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="min-h-screen bg-gray-50/80">
      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <MdOutlineCategory className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  Preference Management
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage categories and preferences
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-3 mt-5 sm:grid-cols-4 md:gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-lg font-bold text-white uppercase md:text-lg">Total</p>
                  <p className="text-xl font-bold text-white md:text-2xl mt-0.5">{preference?.length || 0}</p>
                </div>
                <div className="p-2 rounded-xl bg-blue-500/30 shadow-inner">
                  <FiFolder className="w-4 h-4 text-white md:w-5 md:h-5" />
                </div>
              </div>
            </div>
            {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Active</p>
                  <p className="text-xl font-bold text-emerald-300 md:text-2xl mt-0.5">{preference?.filter(c => !c?.isDisable)?.length || 0}</p>
                </div>
                <div className="p-2 rounded-xl bg-emerald-500/30 shadow-inner">
                  <FiCheckCircle className="w-4 h-4 text-emerald-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div> */}
            {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Inactive</p>
                  <p className="text-xl font-bold text-rose-300 md:text-2xl mt-0.5">{preference?.filter(c => c?.isDisable)?.length || 0}</p>
                </div>
                <div className="p-2 rounded-xl bg-rose-500/30 shadow-inner">
                  <FiXCircle className="w-4 h-4 text-rose-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div> */}
            {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Categories</p>
                  <p className="text-xl font-bold text-amber-300 md:text-2xl mt-0.5">{filteredCategories.length}</p>
                </div>
                <div className="p-2 rounded-xl bg-amber-500/30 shadow-inner">
                  <FiTag className="w-4 h-4 text-amber-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          {/* Create Category Section */}
          <div className="p-4 md:p-6 border-b border-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
                  <FiPlus className="w-4 h-4 text-[#715EFE]" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-700">Create New Category</h3>
                  <p className="text-xs text-gray-400 hidden sm:block">Add a new category to the system</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#715EFE] rounded-lg hover:bg-[#5b48d7] transition-all duration-200 shadow-sm hover:shadow-md"
                  onClick={handleFileUploadModal}
                >
                  <FiUpload className="w-4 h-4" />
                  <span>Upload</span>
                </button>
                <button
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-[#715EFE] bg-white border border-[#715EFE] rounded-lg hover:bg-[#715EFE] hover:text-white transition-all duration-200"
                  onClick={handleDownloadSample}
                >
                  <FiDownload className="w-4 h-4" />
                  <span>Sample</span>
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 mt-4 sm:grid-cols-3">
              <div className="sm:col-span-2">
                <div className="relative">
                  <input
                    className="w-full px-4 py-2.5 pl-10 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                    type="text"
                    name="name"
                    id="name"
                    value={inputValue?.name || ''}
                    onChange={handleCreateOnChange}
                    placeholder="Enter category name..."
                  />
                  <FiTag className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                </div>
                {error.name && <p className="mt-1 text-sm text-red-500">{error.name}</p>}
              </div>
              <div>
                <button
                  className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-[#855DF6] to-[#715EFE] rounded-lg hover:shadow-lg hover:shadow-[#715EFE]/25 transition-all duration-200"
                  onClick={handleCreateCat}
                >
                  <FiPlus className="w-4 h-4" />
                  <span>Create Category</span>
                </button>
              </div>
            </div>
          </div>

          {/* Categories List Section */}
          <div className="p-4 md:p-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
              <div className="flex items-center gap-3">
                <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
                  <FiList className="w-4 h-4 text-[#715EFE]" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-700">Created Categories</h3>
                  <p className="text-xs text-gray-400">{sortedCategories.length} categories</p>
                </div>
              </div>
              
              {/* Search */}
              <div className="relative w-full sm:w-64">
                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search categories..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                />
              </div>
            </div>

            {/* Categories Grid */}
            <div className="flex flex-wrap gap-3">
              {sortedCategories.length > 0 ? (
                sortedCategories.map((e, index) => (
                  <div
                    key={index}
                    className="group flex items-center gap-2 bg-[#F1F4F9] border border-[#D8D8D8] rounded-full px-4 py-2 hover:bg-[#E9E6FB] hover:border-[#715EFE] transition-all duration-200 cursor-pointer"
                  >
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                        <FiTag className="w-3 h-3 text-[#715EFE]" />
                      </div>
                      <span 
                        className="text-sm font-medium text-gray-800 truncate max-w-[150px] capitalize"
                        title={e?.name}
                      >
                        {e?.name}
                      </span>
                    </div>

                    <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      <button
                        onClick={() => handleDelete(e)}
                        className="p-1 text-rose-500 hover:text-rose-700 hover:bg-rose-50 rounded-full transition-all duration-200"
                        title="Delete"
                      >
                        <FiTrash2 className="w-3.5 h-3.5" />
                      </button>
                      <button
                        onClick={() => handleCatEdit(e, index)}
                        className="p-1 text-blue-500 hover:text-blue-700 hover:bg-blue-50 rounded-full transition-all duration-200"
                        title="Edit"
                      >
                        <FiEdit2 className="w-3.5 h-3.5" />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="w-full py-12 text-center">
                  <div className="flex flex-col items-center gap-3">
                    <div className="p-4 bg-gray-50 rounded-full">
                      <FiFolder className="w-10 h-10 text-gray-300" />
                    </div>
                    <p className="text-sm font-medium text-gray-500">No categories found</p>
                    <p className="text-xs text-gray-400">Create your first category above</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Modals */}
      {isModalOpen && (
        <EditCatModal 
          setIsModalOpen={setIsModalOpen} 
          selectedCategory={selectedCategory} 
          handleInputChange={handleInputChange} 
          handleSave={handleSave} 
        />
      )}

      {isActionModal && (
        <SimpleDeleteModal 
          isOpen={isActionModal} 
          title={`Delete Category`} 
          description={`Are you sure you want to delete "${Info?.name || 'this category'}"?`} 
          onCancel={toggleStatusModal} 
          onDelete={handleSubmit} 
        />
      )}

      {isUploadModal && (
        <UploadModal
          isOpen={isUploadModal}
          setIsOpen={setIsUploadModal}
          handleUploadFile={() => handleUploadFile(file)}
          setFile={setFile}
          file={file}
        />
      )}
    </div>
  )
}

export default PreferenceMangment